import { handleActions } from 'redux-actions';

import endpoints from '../../../config/endpoints';
import { LOCATION_CHANGE, replace } from 'react-router-redux';
import { reset, getFormValues } from 'redux-form';

import http from '../../shared/http';
import intl from '../../shared/intl';
import checkPermissions from '../../shared/check-permissions';

import cloneDeep from 'lodash/cloneDeep';

// action types
const FETCH_DATA_SUCCESS = 'payoutRequestsPayoutMatrix/fetch-data-success';
const FETCH_DATA_ERROR = 'payoutRequestsPayoutMatrix/fetch-data-error';

const REQUEST_SUCCESS = 'payoutRequestsPayoutMatrix/REQUEST_SUCCESS';
const REQUEST_ERR = 'payoutRequestsPayoutMatrix/REQUEST_ERR';

const TOGGLE_PROGRESS_BAR = 'payoutRequestsPayoutMatrix/toggle-progress-bar';
const CHANGE_HIGHLIGHTED_COUNTRY_ID = 'payoutRequestsPayoutMatrix/CHANGE_HIGHLIGHTED_COUNTRY_ID';

const APPLY = 'payoutRequestsPayoutMatrix/apply';

// permissions
export const allowedPermissions = {
	payout_requests_review: 'payout_requests_review',
	payout_requests_view_matrix_and_history: 'payout_requests_view_matrix_and_history'
};

const table = {
	columns: {
		niche_model: { index: 'niche_model', className: 'fixed-col', title: 'niche_model' }
	}
};
// initial state
const initialState = {
	data: null,
	table,
	showProgressBar: false,
	error: false,
	highlightedCountryId: null,
	isRequestFormVisible: false,
	sortedPayoutSystemsList: []
};

// actions
export const actions = Object.assign(
	{
		fetchData: () => (dispatch, getState) => {
			dispatch(actions.toggleProgressBar());

			return http({
				url: `${endpoints.PAYOUT_REQUESTS.BASE}/matrix`,
				method: 'get',
				actions: [FETCH_DATA_SUCCESS, FETCH_DATA_ERROR]
			})(dispatch);
		},
		changeHighlightedCountryId: (payload) => ({
			type: CHANGE_HIGHLIGHTED_COUNTRY_ID,
			payload
		}),

		submitCell: ({ main_niche, main_sale_model, country_id }, formName) => (dispatch, getState) => {
			const { amount, max_amount } = getFormValues(formName)(getState());

			return http({
				url: `${endpoints.PAYOUT_REQUESTS.BASE}/matrix`,
				method: 'put',
				data: { niche: main_niche, sale_model: main_sale_model, country_id, amount, max_amount },
				actions: [REQUEST_SUCCESS, REQUEST_ERR]
			})(dispatch)
				.then(action => {
					if (action.type === REQUEST_SUCCESS) {
						dispatch(reset(formName));

						return http({
							url: `${endpoints.PAYOUT_REQUESTS.BASE}/matrix`,
							method: 'get',
							actions: [FETCH_DATA_SUCCESS, FETCH_DATA_ERROR]
						})(dispatch);
					}
				});
		},

		apply: () => dispatch => {
			dispatch(actions.fetchData());
		},

		clear: () => (dispatch, getState) => {
			dispatch(replace('/payouts/'));
		},
		toggleProgressBar: () => ({
			type: TOGGLE_PROGRESS_BAR
		})
	}
);

const reducers = Object.assign(
	{
		[LOCATION_CHANGE]: (state, action) => {
			return initialState;
		},
		[FETCH_DATA_SUCCESS]: (state, action) => {
			return {
				...state,
				data: action.payload.data && action.payload.data.data,
				columns: action.payload.data && action.payload.data.cols,
				offerSaleModelsMapping: action.payload.data && action.payload.data.offerSaleModelsMapping,
				rowsKeys: action.payload.data && action.payload.data.rowsKeys,
				showProgressBar: false,
				error: false
			};
		},
		[APPLY]: (state, action) => {
			return {
				...state,
				selectedFilters: {
					...action.payload
				}
			};
		},
		[FETCH_DATA_ERROR]: state => ({ ...state, error: true, showProgressBar: false }),
		[CHANGE_HIGHLIGHTED_COUNTRY_ID]: (state, action) => ({ ...state, highlightedCountryId: action.payload }),
		[TOGGLE_PROGRESS_BAR]: state => ({ ...state, showProgressBar: !state.showProgressBar })
	}
);

// reducers
export default handleActions(reducers, cloneDeep(initialState));

// selectors
export const selectors = {
	getData: state => state.payoutRequestsPayoutMatrix.data,
	getHighlightedCountryId: state => state.payoutRequestsPayoutMatrix.highlightedCountryId,
	getProgressBar: state => state.payoutRequestsPayoutMatrix.showProgressBar,
	getTable: state => {
		const { table, data, columns, rowsKeys, offerSaleModelsMapping } = state.payoutRequestsPayoutMatrix;

		const rowsKeysList = (rowsKeys || []).reduce((acc, val, index) => {
			const r = rowsKeys && rowsKeys[index + 1];
			return [...acc].concat(r && r.main_sale_model !== val.main_sale_model ? [val, {}] : [val]);
		}, []);

		return {
			headers: Object.values(table.columns),
			offerSaleModelsMapping,
			columns: columns || [],
			rowsKeys: rowsKeysList,
			rows: data || []
		};
	},
	getIntl: state => intl(state),
	getCan: state => checkPermissions(state, allowedPermissions),
	getError: state => state.payoutRequestsPayoutMatrix.error
};



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/payout-requests/payout-matrix/index.js